import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IEventSpace, EventSpaceState } from "./eventspaceModal";
import {
  ActiveInactiveEventSpace,
  createEventSpace,
  deleteEventSpace,
  EventSpaceImageUpload,
  getAllEventSpace,
  getEventSpaceByID,
  updateEventSpace,
} from "./services/eventspace.service";

const initialState: EventSpaceState = {
  loading: false,
  formLoading: false,
  error: null,
  EventSpaceList: [],
  EventSpaceDetail: null,
  EventSpaceID: null,
};

const eventspaceSlice = createSlice({
  name: "eventspace",
  initialState,
  reducers: {
    clearEventSpaceDetails: (state) => {
      state.EventSpaceDetail = null;
    },
    setEventSpaceID: (state, action: PayloadAction<number | null>) => {
      state.EventSpaceID = action.payload;
    },
    clearEventSpaceID: (state) => {
      state.EventSpaceID = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllEventSpace.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(
      getAllEventSpace.fulfilled,
      (state, action: PayloadAction<IEventSpace[]>) => {
        state.loading = false;
        state.EventSpaceList = action.payload || [];
      },
    );
    builder.addCase(getAllEventSpace.rejected, (state, action) => {
      state.loading = false;
      state.error = (action.payload as any)?.message || "Something went wrong";
    });

    builder.addCase(createEventSpace.pending, (state) => {
      state.formLoading = true;
    });
    builder.addCase(createEventSpace.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(createEventSpace.rejected, (state) => {
      state.formLoading = false;
    });

    builder.addCase(updateEventSpace.pending, (state) => {
      state.formLoading = true;
    });
    builder.addCase(updateEventSpace.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(updateEventSpace.rejected, (state) => {
      state.formLoading = false;
    });

    builder.addCase(getEventSpaceByID.pending, (state) => {
      state.formLoading = true;
    });
    builder.addCase(
      getEventSpaceByID.fulfilled,
      (state, action: PayloadAction<IEventSpace>) => {
        state.formLoading = false;
        state.EventSpaceDetail = action.payload;
      },
    );
    builder.addCase(getEventSpaceByID.rejected, (state) => {
      state.formLoading = false;
    });

    builder.addCase(deleteEventSpace.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(deleteEventSpace.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteEventSpace.rejected, (state) => {
      state.loading = false;
    });

    builder.addCase(ActiveInactiveEventSpace.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(ActiveInactiveEventSpace.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(ActiveInactiveEventSpace.rejected, (state) => {
      state.loading = false;
    });

    builder.addCase(EventSpaceImageUpload.pending, (state) => {
      state.formLoading = true;
    });
    builder.addCase(EventSpaceImageUpload.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(EventSpaceImageUpload.rejected, (state) => {
      state.formLoading = false;
    });
  },
});

export const { clearEventSpaceDetails, setEventSpaceID, clearEventSpaceID } =
  eventspaceSlice.actions;
export default eventspaceSlice.reducer;
